module.exports = __webpack_public_path__ + "img/img47.f6a7ff35.svg";